import { render, staticRenderFns } from "./GolfCourse.vue?vue&type=template&id=6ef7e832&scoped=true&"
import script from "./GolfCourse.vue?vue&type=script&lang=js&"
export * from "./GolfCourse.vue?vue&type=script&lang=js&"
import style0 from "./GolfCourse.vue?vue&type=style&index=0&id=6ef7e832&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ef7e832",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VPagination } from 'vuetify/lib/components/VPagination';
import { VSimpleCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCardActions,VDataTable,VPagination,VSimpleCheckbox,VSpacer})
